import { render } from "./AssetPage2.vue?vue&type=template&id=03ca65ba&scoped=true"
import script from "./AssetPage2.vue?vue&type=script&lang=js"
export * from "./AssetPage2.vue?vue&type=script&lang=js"

import "./AssetPage2.vue?vue&type=style&index=0&id=03ca65ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ca65ba"]])

export default __exports__